module.exports = __webpack_public_path__ + "5a2750cde0fe7cd8052523e9348c21ac.png";